// src/layouts/MainLayout.jsx
import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const MainLayout = ({ children }) => {
  return (
    <div className="relative" style={{ background: '#000', minHeight: '100vh', width: '100vw' }}>
      <Header />
      {children}
      <Footer />
    </div>
  );
};

export default MainLayout;
